import React from "react";
import { OcChartView } from "./chart-view";
import { useOcChart } from "./use-chart";
import { PRODUCTS } from "oc/configs/constants";

export interface OcChartData {
  value: number;
  valueInLegend?: string | number;
  color: string;
  label: string;
}

export interface OcChartProps {
  data: OcChartData[] | null;
  summaryTitle: string;
  summaryText: string;
  loading?: boolean;
  variant:
    | typeof PRODUCTS.MYLEAVE
    | typeof PRODUCTS.MYCAFETERIA
    | typeof PRODUCTS.MYTIMESHEET;
}

export const OcChart: React.FC<OcChartProps> = ({ variant, ...props }) => {
  const extraProps = useOcChart({ variant });

  return <OcChartView {...props} {...extraProps} variant={variant} />;
};
